/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Common_UpdatedInputs */

const en_fc_common_updated = /** @type {(inputs: Fc_Common_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated October 2026`)
};

/**
* | output |
* | --- |
* | "Updated October 2026" |
*
* @param {Fc_Common_UpdatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_common_updated = /** @type {((inputs?: Fc_Common_UpdatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Common_UpdatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_common_updated(inputs)
});
export { fc_common_updated as "fc.common.updated" }